import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/ChevronLeft';
import { useRoutes } from '../../hooks';

export const BackButton = ({ className }: { className?: string }) => {
  const [rootPath, setRootPath] = useState('');
  const location = useLocation();
  const history = useHistory();
  const { paths } = useRoutes();

  const rootPaths = useMemo(
    () => [
      paths.asct.path,
      paths.security.path,
      paths.safety.path,
      paths.versement.path,
      paths.proprete.path,
      paths.avitaillement.path,
      paths.aetgv.path,
      paths.prmAssistance.path,
      paths.emargement.path,
      paths.bulletincomposition.path,
      paths.restauration.path
    ],
    [paths]
  );

  const goBack = useCallback(() => {
    history.goBack();
  }, [history]);

  useEffect(() => {
    const { pathname } = location;
    const parentPath = rootPaths.find((path) => pathname !== path && pathname.includes(path));
    setRootPath(parentPath || '');
  }, [location, rootPaths]);

  if (!rootPath) return null;
  return (
    <IconButton onClick={goBack} className={className}>
      <DeleteIcon fontSize="large" />
    </IconButton>
  );
};

export default BackButton;
